import type { ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
  StickyViewHeaderExtras,
} from '@/components/StickyViewHeader'
import { TabBar, TabItem } from '@/components/TabBar'
import { ViewHeading } from '@/components/ViewHeading'
import { links } from '@/utils/link'
import { useMatch } from 'react-router'
import { type MotionValue } from 'motion/react'

export interface PayoutsAdminHeaderProps {
  scrollOffset: MotionValue<number>
  children?: ReactNode
}

/**
 * The PayoutsAdminHeader
 */
export function PayoutsAdminHeader({
  scrollOffset,
  children,
}: PayoutsAdminHeaderProps) {
  return (
    <>
      <StickyViewHeader
        bordered
        scrollOffset={scrollOffset}
        tabBar={
          <TabBar align="left">
            <PayoutsTabItem to={links.adminPayoutsReview()}>
              Pending
            </PayoutsTabItem>
            <PayoutsTabItem to={links.adminPayoutsTransactions()}>
              History
            </PayoutsTabItem>
          </TabBar>
        }
      >
        <StickyViewHeaderMain>
          <ViewHeading primaryText="Payouts" secondaryText="Transactions" />
        </StickyViewHeaderMain>
        <StickyViewHeaderSpacer />
        <StickyViewHeaderExtras>{children}</StickyViewHeaderExtras>
      </StickyViewHeader>
    </>
  )
}

interface PayoutsTabItemProps {
  children?: ReactNode
  to: string
}

/**
 * Payouts Tab Item
 */
function PayoutsTabItem({ children, to }: PayoutsTabItemProps) {
  const match = useMatch(to)
  return (
    <TabItem to={to} active={!!match}>
      {children}
    </TabItem>
  )
}
